import { queryOptions, useQuery } from "@tanstack/react-query";
import { neWebApi } from "../../../../api";
import { neWebUrls } from "../../../../ne-web-urls";
import type { PPADeliveryInvoicesResponse } from "../PPAInvoicePage.types";

export const ppaDeliveryInvoicesQueryOptions = queryOptions({
  queryKey: ["ppaDeliveryInvoices"],
  queryFn: fetchPPADeliveryInvoices
});

async function fetchPPADeliveryInvoices() {
  const ppaDeliveryInvoicesUrl = neWebUrls.api.ppaDirectDeliveryInvoices();
  const response = await neWebApi.get<PPADeliveryInvoicesResponse>(
    ppaDeliveryInvoicesUrl
  );

  return response.data;
}

export function usePPADirectDeliveryInvoices() {
  return useQuery(ppaDeliveryInvoicesQueryOptions);
}
